<template>
  <div :class="'dropdownlist dropdownlist-'+hash" @click="showlist">
      <div class="content">
        <span class="text">{{langTransfer(value.list[value.selectvalue])}}</span>
        <span class="select-icon" :style="{borderTop:'5px solid '+themeColor}"></span>
      </div>
      <div class="list" v-if="isshow">
          <ul>
              <li v-for="(t,index) in value.list" @mouseenter="hover = index"
                @mouseleave="hover = -1" :style="{background: hover === index ? themeColor : ''}" @click.stop="selectlist(index)">{{langTransfer(t)}}
              </li>
          </ul>
      </div> 
  </div>
</template>
<script type="text/javascript">
export default 
{
    data(){
      return {
          hover:-1,
          isshow:false,
          hash:''
      }
    },
    props: {
        value: Object,
        default: true
    },
    computed: {
        themeColor () {
            return this.$store.state.themeColor
        }
    },
    mounted() {
        this.hash = this.mathNum();
        let _hash = this.hash;
        window.addEventListener("click", (e)=>{
          try
          {
            let flag =document.getElementsByClassName('dropdownlist-'+ _hash)[0].contains(e.target)
            if(flag)return;
          }catch(e)
          {
            return;
          }
         
            this.isshow = false;
        });
    },
    methods:{
      mathNum() {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      },
      showlist()
      {
        this.isshow = true;
      },
      selectlist(index)
      {
          this.value.selectvalue=index;
          this.isshow = false;
          this.hover = -1;
      }
    }
}
</script>
<style lang="scss" scoped>
    .select-icon {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        transition: transform 0.2s;
    }
    .dropdownlist
    {

        .content{
            cursor: pointer;
            min-width: 80px;
            height: 24px;
            background: #FFFFFF;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            margin-right:28px;
            line-height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;      
            &>span{
                display: inline-block;
            }
            .text{
                min-width: 33px;
            }
        }
    }        
    .list
    {
        max-height: 200px;
        overflow: auto;
        /*display: none;*/
        z-index: 999;
        background:red;
        min-width: 80px;
        position: absolute;
        color: #475669;
        background: white;
        border: 1px solid #D6DCE2;
        border-radius: 4px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
        ul{
            list-style: none;
            padding-left: 0;
            li{
                height: 30px;
                line-height: 30px;
                text-align: center;
                cursor: pointer;
                &:hover {
                  color:white;
                }
            }
        }
    }
    /*.dropdownlist:hover .list{
          display: block;
          z-index: 299;
    }*/

    
</style>